module.exports = __webpack_public_path__ + "static/img/cabinet24_3.913e32bb.gif";